const encodeFinderName = (name) =>
    String(name || '')
        .trim()
        .replace(/\s+/g, 'Q1SPACEQ1');

const cloneFinder = (value) => JSON.parse(JSON.stringify(value && typeof value === 'object' ? value : {}));

const toNumberOrEmpty = (value) => {
    const normalizedValue = String(value ?? '')
        .trim()
        .replace(',', '.');

    if (!normalizedValue) {
        return '';
    }

    const parsedValue = Number(normalizedValue);

    return Number.isFinite(parsedValue) ? parsedValue : '';
};

const normalizeFinderSelection = (values = []) => (Array.isArray(values) ? values : []).map((value) => String(value || '').trim()).filter(Boolean);

export function buildChartingFavoriteFolderPayload({ name = '', color = '', newName = '', newColor = '' } = {}) {
    return {
        name,
        ...(color ? { color } : {}),
        ...(newName ? { new_name: newName } : {}),
        ...(newColor ? { new_color: newColor } : {})
    };
}

export function buildChartingFavoriteMembershipPayload({ ticker = '', direction = '', folderName = '' } = {}) {
    return {
        stock: JSON.stringify({
            ticker,
            direccio: direction,
            folder_name: folderName
        })
    };
}

export function buildChartingSavedSearchPayload({ name = '', filters = {} } = {}) {
    return {
        name: encodeFinderName(name),
        finder: JSON.stringify(filters || {})
    };
}

export function buildChartingSavedSearchRenamePayload({ name = '', newName = '' } = {}) {
    return {
        name,
        new_name: encodeFinderName(newName)
    };
}

export function buildChartingDescriptionSearchPayload(term = '') {
    return {
        search_term: String(term || '').trim()
    };
}

export function buildChartingFinderObject(filters = {}, baseFinder = {}) {
    const finder = cloneFinder(baseFinder);
    const filterState = filters && typeof filters === 'object' ? filters : {};

    finder.tae_checkboxes = {
        ...(finder.tae_checkboxes || {}),
        M: Boolean(filterState?.profitabilityBands?.M),
        A: Boolean(filterState?.profitabilityBands?.A),
        B: Boolean(filterState?.profitabilityBands?.B),
        C: Boolean(filterState?.profitabilityBands?.C),
        D: Boolean(filterState?.profitabilityBands?.D)
    };
    finder.es_ipo = [Boolean(filterState?.timing?.monthly), Boolean(filterState?.timing?.ipo)];
    finder.direccio = [Boolean(filterState?.directions?.bearish), Boolean(filterState?.directions?.bullish)];
    finder.entry_type = {
        ...(finder.entry_type || {}),
        per: Boolean(filterState?.entryTypes?.per),
        0: Boolean(filterState?.entryTypes?.rr),
        1: Boolean(filterState?.entryTypes?.rra),
        2: Boolean(filterState?.entryTypes?.lt),
        3: Boolean(filterState?.entryTypes?.lta),
        6: Boolean(filterState?.entryTypes?.se)
    };
    finder.value_type = {
        ...(finder.value_type || {}),
        Stock: Boolean(filterState?.valueTypes?.Stock),
        ETF: Boolean(filterState?.valueTypes?.ETF)
    };
    finder.min_amount = toNumberOrEmpty(filterState?.amount?.min);
    finder.max_amount = toNumberOrEmpty(filterState?.amount?.max);
    finder.min_entry_distance = toNumberOrEmpty(filterState?.entryDistance?.min);
    finder.max_entry_distance = toNumberOrEmpty(filterState?.entryDistance?.max);
    finder.min_edad = toNumberOrEmpty(filterState?.age?.min);
    finder.max_edad = toNumberOrEmpty(filterState?.age?.max);
    finder.dividends = [Boolean(filterState?.dividends?.zero), Boolean(filterState?.dividends?.one), Boolean(filterState?.dividends?.two), Boolean(filterState?.dividends?.threePlus)];
    finder.currency = normalizeFinderSelection(filterState?.currencies);
    finder.country = normalizeFinderSelection(filterState?.countries);
    finder.sector = normalizeFinderSelection(filterState?.sectors);
    finder.industry = normalizeFinderSelection(filterState?.industries);

    return finder;
}

export function buildChartingLastSearchPayload({ filters = {}, baseFinder = {} } = {}) {
    return {
        finder: JSON.stringify(buildChartingFinderObject(filters, baseFinder))
    };
}
